import * as React from 'react';
import { NumericFormat } from 'react-number-format';
import TextField from '@mui/material/TextField';
import './PriceInput.scss';
import { produce } from 'immer';
import { cloneDeep } from 'lodash';
import { InputAdornment, Stack, Tooltip, TooltipProps, useTheme } from '@mui/material';
import { Quote } from '@/views/components/componentsUI/TableUIActionInputElement';
import TypographyElement from '../typography/TypographyElement';
import ViewNumberFormat from './ViewNumberFormat';
import { useTranslation } from 'react-i18next';

type TextAlign = "center" | "justify" | "left" | "right" | "start"

type Props = {
    // value: string | number | undefined
    align?: TextAlign
    color?: string
    fullWidth?: boolean,

    realValue?: string | number
    handleChangeInput: (event: React.ChangeEvent<HTMLInputElement>, isValid: boolean) => void
    error?: boolean
    prefix?: string
    suffix?: string
    decimalScale?: number
    thousandSeparator?: '.' | ','
    // decimalSeparator?: '.' | ','
    minValue?: number, // min must less or equal 0 or value pass on parent == minValue
    maxValue?: number,
    endAdornment?: string
    startAdornment?: string
    allowNegative?: boolean

    symbol?: string,
    quote?: Quote
    handleChangeValid: (isValid: boolean) => void
    isOddLot?: boolean
    placementTooltip?: TooltipProps["placement"]
}

export default function QuantityInput(props: Props) {
    const { align, color, fullWidth, realValue, handleChangeInput, error, prefix,
        decimalScale, suffix, thousandSeparator, //decimalSeparator
        minValue, maxValue, endAdornment, startAdornment, allowNegative, symbol, quote, handleChangeValid, isOddLot, placementTooltip
    } = props

    const [valueMask, setValueMask] = React.useState(realValue)
    const [contextError, setContextError] = React.useState<string>('')

    const refNoTouch = React.useRef<boolean>(true)
    const theme = useTheme()
    const { t } = useTranslation()

    // React.useEffect(() => {
    //     // symbol
    //     console.log('ha_check_symbol', symbol)
    // }, [symbol])

    React.useEffect(() => {
        if (refNoTouch) {
            setValueMask(realValue)
        }
    }, [refNoTouch, realValue])

    React.useEffect(() => {
        if (realValue === 0) {
            handleChangeValid(false);
            setContextError(t("copytrade.common.error.noEmptyInputNumber"))
            return;
        }

        if (isOddLot === true) {
            if (quote && quote?.tradelot !== undefined && realValue !== undefined && ((Number.parseFloat(realValue.toString()) >= quote?.tradelot))) {
                setContextError(t("copytrade.common.error.lotWrong"))
                handleChangeValid(false);
            } else {
                handleChangeValid(true);
            }
        } else {
            if (quote && quote?.tradelot !== undefined && realValue !== undefined) {
                if (((Number.parseFloat(realValue.toString()) % quote?.tradelot) !== 0)) {
                    setContextError(t("copytrade.common.error.lotWrong"))
                    handleChangeValid(false);
                }
            }
        }
    }, [quote, isOddLot])

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        refNoTouch.current = false
        setValueMask(event.target.value)
    };

    const MIN = React.useMemo(() => {
        return minValue === 0 ? 0 : minValue ? minValue : Number.MIN_SAFE_INTEGER
    }, [minValue])

    const MAX = React.useMemo(() => {
        return maxValue === 0 ? 0 : maxValue ? maxValue : Number.MAX_SAFE_INTEGER
    }, [maxValue])

    const slotPropsInput = React.useMemo(() => {
        let rawSlotPropsInput: any = {
            endAdornment: <InputAdornment position="end">{endAdornment}</InputAdornment>,
            startAdornment: <InputAdornment position="start">{startAdornment}</InputAdornment>,
        }
        if (endAdornment === undefined) {
            delete rawSlotPropsInput.endAdornment
        }
        if (startAdornment === undefined) {
            delete rawSlotPropsInput.startAdornment
        }
        return rawSlotPropsInput
    }, [endAdornment, startAdornment])



    return (
        <>
            <Stack direction={'column'} spacing={1}>
                {/* <Stack direction={'row'} justifyContent={'space-between'} spacing={1} visibility={'hidden'}>
                    <TypographyElement FontSizeElement='12px' FontWeightElement={400} sx={{ color: theme.palette.symbol?.ceiling }}>{quote?.ceiling}</TypographyElement>
                    <TypographyElement FontSizeElement='12px' FontWeightElement={400} sx={{ color: theme.palette.symbol?.floor }}>{quote?.floor}</TypographyElement>
                    <TypographyElement FontSizeElement='12px' FontWeightElement={400} sx={{ color: theme.palette.symbol?.reference }}>{quote?.reference}</TypographyElement>
                </Stack> */}
                <Stack sx={{ minWidth: 100 }} direction={'row'} justifyContent={'space-between'} spacing={1} >
                    <TypographyElement FontSizeElement='12px' FontWeightElement={400} sx={{ color: theme.palette.text.secondary }}>Tối đa</TypographyElement>
                    <TypographyElement FontSizeElement='12px' FontWeightElement={400} sx={{ color: theme.palette.text.primary }}> <ViewNumberFormat displayType='text' color='inherit' value={maxValue} /></TypographyElement>
                </Stack>

                <Tooltip placement={placementTooltip ?? "bottom"} title={error ? contextError : ""}>
                    <NumericFormat
                        onValueChange={(values, sourceInfo) => {
                            console.log('ha_check_sourceInfo', { values, sourceInfo });
                            const cloneEvent = cloneDeep(sourceInfo.event) as React.ChangeEvent<HTMLInputElement>
                            const cloneTarget: any = cloneDeep(sourceInfo?.event?.target)
                            const updatedEvent = produce({ ...cloneEvent }, (draft: React.ChangeEvent<HTMLInputElement>) => {
                                if (draft && draft.target && cloneTarget) {
                                    cloneTarget.value = values?.floatValue?.toString() ?? '';
                                    draft.target = cloneTarget// values?.floatValue?.toString() ?? '';
                                    // draft.target.value =  values?.floatValue?.toString() ?? '';

                                }
                            }) as React.ChangeEvent<HTMLInputElement>;

                            if (updatedEvent && updatedEvent.target) {

                                if (values?.floatValue === undefined && values?.value === '') {
                                    setContextError(t("copytrade.common.error.noEmpty"))
                                    handleChangeInput(updatedEvent, false);
                                }

                                if (values?.floatValue === 0) {
                                    handleChangeInput(updatedEvent, false);
                                    setContextError(t("copytrade.common.error.noZero"))
                                    return;
                                }

                                if (isOddLot === true) {
                                    if (quote && quote?.tradelot !== undefined && values?.floatValue !== undefined && (values?.floatValue >= quote?.tradelot)) {
                                        setContextError(t("copytrade.common.error.lotWrong"))
                                        handleChangeInput(updatedEvent, false);
                                    } else {
                                        handleChangeInput(updatedEvent, true);
                                    }
                                } else {
                                    if (quote && quote?.tradelot !== undefined && values?.floatValue !== undefined) {
                                        if ((values?.floatValue % quote?.tradelot === 0)) {
                                            handleChangeInput(updatedEvent, true);
                                        } else {
                                            setContextError(t("copytrade.common.error.lotWrong"))
                                            handleChangeInput(updatedEvent, false);
                                        }
                                    }
                                }
                            }
                        }}
                        className='mf-number-input-format'
                        value={valueMask}
                        onChange={handleChange}
                        customInput={TextField}
                        thousandSeparator={thousandSeparator ?? ','}
                        decimalSeparator={thousandSeparator === '.' ? ',' : '.'}
                        // valueIsNumericString={false}
                        decimalScale={decimalScale ?? 0}
                        prefix={prefix}
                        suffix={suffix}
                        // variant="standard"
                        sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, background: theme.palette.background.input, '& .MuiInputBase-input': { color: `${color ?? theme.palette.text.primary} !important` } }}
                        slotProps={{
                            htmlInput: { sx: { textAlign: align ? align : 'start' } },
                            input: slotPropsInput,
                        }}
                        size={'small'}
                        fullWidth={fullWidth ?? true}
                        error={error}
                        max={MAX}
                        min={MIN}
                        allowNegative={allowNegative ?? false}

                        isAllowed={(values) => {
                            const { floatValue } = values;
                            if (floatValue === undefined) {
                                return true
                            }
                            return (floatValue >= MIN) && (floatValue <= MAX)
                        }}
                    />
                </Tooltip>
                {/* {error === true &&
                    <FormHelperText error id="value">
                        "Giá phải nằm trong khoảng trần sàn"
                    </FormHelperText>
                } */}
            </Stack>
        </>
    );
}

